import * as resultTypes from '../constants/resultTypes';

export function convertResultToSymbol(result) {

  switch (result) {
    case resultTypes.AVAILABLE: return '○';
    case resultTypes.MIGHT_BE_NOT_AVAILABLE: return '△';
    case resultTypes.NOT_AVAILABLE:
    case resultTypes.NOT_AVAILABLE_INTERNAL: return '×';
    case resultTypes.NOT_FIND: return '-';
    case resultTypes.SEARCH_ERROR: return 'Error';
    default: return 'Undefined';
  }

}

export function displayResult(imei) {
  if (!imei) { return false; }
  return true;
}

export function checkDigit(imei) {

  if (!(imei.match(/^[0-9]+$/))) { return false; }

  switch (imei.length) {
    case 15: {
      let d =  imei.split('')
        .map( (x) => parseInt(x) )
        .map( (x,i) => i % 2 ? x * 2 : x )
        .map((x) => x > 9 ? x-9 : x);
      let sum = d.reduce((accum, x) => accum += x);
      return !(sum % 10);
    }
    default:
      return false;
  }

}

export function errorResultType(error) {

  if (typeof error.response === "undefined") {
    return resultTypes.SEARCH_ERROR;
  }

  return resultTypes.SEARCH_ERROR;

}

